import React, { useState } from 'react'
import { useAuth } from '../../Auth/AuthProvider'
import {
  getProviderLabels,
  hasPasswordProvider,
} from '../../utils/authProviders'
import { Button } from '@/Components/ui/button'

export default function SecuritySection() {
  const { user, email, resetPassword } = useAuth()
  const [sending, setSending] = useState(false)
  const [message, setMessage] = useState(null)
  const [error, setError] = useState(null)

  const canResetPassword = hasPasswordProvider(user)
  const providerLabels = getProviderLabels(user)

  const handleReset = async () => {
    if (!email || sending) return

    setSending(true)
    setMessage(null)
    setError(null)
    try {
      await resetPassword(email)
      setMessage('Password reset email sent. Check your inbox.')
    } catch (err) {
      console.error('Failed to send password reset', err)
      setError(err?.message || 'Could not send password reset email.')
    } finally {
      setSending(false)
    }
  }

  return (
    <section className="space-y-4 border-b border-mauve-200 py-8">
      <div>
        <h2 className="text-lg font-semibold text-mauve-900">Security</h2>
        <p className="mt-1 text-sm text-mauve-600">
          Sign-in methods linked to this account
          {providerLabels.length > 0 ? `: ${providerLabels.join(', ')}.` : '.'}
        </p>
      </div>

      {canResetPassword ? (
        <div className="space-y-2">
          <p className="text-sm text-mauve-600">
            We’ll email a link to reset your password for {email}.
          </p>
          <Button
            type="button"
            variant="outline"
            disabled={sending || !email}
            onClick={handleReset}
          >
            {sending ? 'Sending…' : 'Send password reset email'}
          </Button>
          {message ? <p className="text-sm text-green-700">{message}</p> : null}
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
        </div>
      ) : (
        <p className="text-sm text-mauve-600">
          Password is managed by your sign-in provider
          {providerLabels.length > 0 ? ` (${providerLabels.join(', ')})` : ''}.
          Change it in that provider’s account settings.
        </p>
      )}
    </section>
  )
}
